/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";

export const  getRomaneioSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  filtro.fields = ['*']
  return filtro
}
export const RomaneioSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.addOrder('dt_romaneio', 'asc')
    filtro.join.addLeft('rotas', 'rotas.rota_id', 'romaneios.rota_id')
  return filtro
}
